import { useEffect, useState } from 'react';
import { InvoiceBase } from '../../types/Invoice';
import http from '../../api/axios';
import { apiUrl } from '../../api/apiUrl';
import { InvoiceForm } from '../Admin/InvoicePage/InvoiceForm';
import { format } from 'date-fns';
import { dateSubmitFormat } from '../../types/core/date.types';
import { Currency } from '../../types/Currency';

interface Props {
  id: string;
}

export interface PrintData {
  fullName: string | null;
  phoneNumber: string | null;
  codeBookItemsUseCode: boolean | null;
  maxDecimalNumUnitPrice: number | null;
}

/**
 * Print view for invoice
 * not accesible from menu only direct url (invoice-pdf/:id)
 */
export const PrintInvoicePage = ({ id }: Props) => {
  const [invoiceData, setInvoiceData] = useState<InvoiceBase | null>(null);
  const [currenciesToTaxDate, setCurrenciesToTaxDate] = useState<Currency[] | null>(null);

  /**
   * Loads currencies by date of taxable transaction
   */
  const fetchCurrenciesData = async () => {
    if (!invoiceData || !invoiceData.dateOfTaxableTransaction) return;
    const date = invoiceData.currencyRatesDate ?? invoiceData.dateOfTaxableTransaction;
    const response = await http.apiGet({
      url: `${apiUrl.CURRENCY_GET_LIST}?date=${format(new Date(date), dateSubmitFormat)}`,
    });
    if (response?.data) setCurrenciesToTaxDate(response?.data);
  };

  /**
   * Loads Invoice data
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.ACCOUNTING_DOCUMENT_ITEM}?id=${id}`,
    });
    setInvoiceData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchCurrenciesData();
  }, [invoiceData]);

  if (!id) return <>Undefined invoice ID</>;
  if (!invoiceData || !currenciesToTaxDate) return <>Loading...</>;
  return (
    <InvoiceForm
      dateOfTaxableTransaction={invoiceData.dateOfTaxableTransaction as Date}
      data={invoiceData}
      documentNumber={invoiceData.documentNumber}
      currenciesToTaxDate={currenciesToTaxDate}
      isPrint
    />
  );
};
